import React from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import { DEFAULT_PAGES } from "./constants/global";
import NotFound from "./pages/404";
import { getCurrentUserRole } from "./reducers";

const Diverter = ({ location: { state } }) => {
  const role = useSelector(getCurrentUserRole);
  const page = DEFAULT_PAGES[role];
  if (page !== undefined) {
    return <Redirect to={page} />;
  } else {
    return <NotFound />;
  }
};

export default Diverter;
